<template lang="pug">
  .content__video(v-if="showDialog")
    .video-wrapper
      v-icon.close.material-icons(@click="closeDialog()") clear
      #player-overlay
        video(
          width="400"
          height="256"
          controls
          autoplay
        )
          source(src="/videos/arroyos_de_asuncion_720p.mp4" type="video/mp4")
          source(src="/videos/arroyos_de_asuncion_720p.webm" type="video/webm")
          source(src="/videos/arroyos_de_asuncion_720p.ogv" type="video/ogg")

</template>

<script>
export default {
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    closeDialog () {
      this.showDialog = false
    }
  },
  mounted () {
    this.showDialog = true
  }
}

</script>

<style lang="stylus" scoped>
  video
    width: 100%
    max-height: 100%
  .content__video
    background-color: #00000094
    display: inline-flex;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 10000;

  .video-wrapper
    display: block
    flex-direction: column
    justify-content: center
    margin-top: 1rem
    z-index: 10000

  audio:not(.md-image), canvas:not(.md-image),
  embed:not(.md-image), iframe:not(.md-image),
  img:not(.md-image), object:not(.md-image),
  video:not(.md-image)
    height: 60vh
    width: 105.8vh
    z-index: 1000

  .v-icon
    color: white
    font-size: 2rem
    z-index: 10000

  .close
    position: absolute
    z-index: 10001

  @media screen and (max-width: 500px)
    .v-icon.close
      position: absolute !important;
      top: 5px !important;
      right: 5px !important;

    .isMobile .video-wrapper
      align-items: center
      display: flex
      position: fixed

    .isMobile .v-icon
      position: fixed
      top: 4rem

    audio:not(.md-image), canvas:not(.md-image),
    embed:not(.md-image), iframe:not(.md-image),
    img:not(.md-image), object:not(.md-image),
    video:not(.md-image)
      height: 83vh
      width: 100%

</style>
